
import navigation from '../../../components/navigation.vue';
import SearchGrid from '../../../components/organization/myTown/SearchGrid.vue';
export default {
  name: 'SearchPage',
  auth: false,
  components: { navigation, SearchGrid },
  data() {
    return {
      states: null,
      cities: null,
      districts: null,
      list: null,
      selectedState: null,
      selectedCity: null,
      selectedDistrict: null,
      orders: {
        서울: 1,
        경기: 2,
        인천: 3,
        부산: 4,
        대구: 5,
        광주: 6,
        대전: 7,
        울산: 8,
        세종: 9,
        강원: 10,
        충북: 11,
        충남: 12,
        전북: 13,
        전남: 14,
        경북: 15,
        경남: 16,
        제주: 17,
      },
      dataType: 'state',
      gridData: [],
    };
  },
  methods: {
    async getState() {
      const res = await this.$axios.get('/api/states');
      this.states = res.data.sort((a, b) => {
        return this.orders[a] - this.orders[b];
      });
      this.setGridData(this.states);
      this.dataType = 'state';
    },
    async getCity(state) {
      this.selectedState = state;
      const res = await this.$axios.get(`/api/cities?state=${state}`);
      this.cities = res.data;
      this.setGridData(this.cities);
      this.dataType = 'city';
    },
    async getRepList(city = null) {
      this.selectedCity = city;
      const res = await this.$axios.get('api/draft/phone-list', {
        params: {
          state: this.selectedState,
          city,
        },
      });
      this.list = res.data;
      this.setGridData(this.list);
      this.dataType = 'district';
    },
    setGridData(data) {
      this.gridData = [...data];
    },
    initState() {
      this.selectedState = null;
      this.selectedCity = null;
      // this.getState();
      this.setGridData(this.states);
      this.dataType = 'state';
    },
    initCity() {
      this.selectedCity = null;
      // this.getCity(this.selectedState);
      this.setGridData(this.cities);
      this.dataType = 'city';
    },

    isNowActiveClass(flag) {
      if (flag === 'city') {
        return this.dataType === 'city' ? 'active' : '';
      } else if (flag === 'district') {
        return this.dataType === 'district' ? 'active' : '';
      }
    },
  },
  async mounted() {
    await this.getState();
  },
};
